module.exports = __webpack_public_path__ + "static/pi8-0515e157c56ececd169381e822dbc6d4.png";